import '../styles/Footer.css';

const TOP_LINKS = [
  { label: 'Support', href: 'https://flare.network/resources/technical-support', newTab: false },
  { label: 'Brand Assets', href: 'https://drive.google.com/drive/u/1/folders/1mPrtIBb2k88E4f1fguEm3eAXLW74xOry?pli=1', newTab: false },
  { label: 'Terms & Conditions', href: 'https://flare.network/privacy-policy', newTab: false },
];

const EXPLORE_LINKS = [
  { label: 'Flare Block Explorer', href: 'https://flare-explorer.flare.network/.', newTab: true },
  { label: 'Flare Portal', href: 'https://portal.flare.network/.', newTab: true },
  { label: 'Systems Explorer', href: 'https://flare-systems-explorer.flare.network/.', newTab: true },
  { label: 'Developer Hub', href: 'https://dev.flare.network/.', newTab: true },
];

const FLARE_LINKS = [
  { label: 'Flare Store', href: 'https://merch.flare.network/.', newTab: true },
  { label: 'Careers', href: 'https://flare.network/careers', newTab: false },
  { label: 'Newsletter', href: 'https://flare.network/sign-up', newTab: false },
  { label: 'Whitepapers', href: 'https://flare.network/whitepapers', newTab: false },
  { label: 'FLR', href: 'https://dev.flare.network/support/.', newTab: true },
];

const SOCIAL_ICONS = [
  { label: 'Discord', path: 'M8 12a2 2 0 104 0 2 2 0 00-4 0zM12 12a2 2 0 104 0 2 2 0 00-4 0z' },
  { label: 'YouTube', path: 'M10 9l5 3-5 3V9z' },
  { label: 'X', path: 'M4 4l16 16M20 4L4 20' },
  { label: 'GitHub', path: 'M12 2a10 10 0 00-3.16 19.49c.5.09.68-.22.68-.48v-1.7c-2.78.6-3.37-1.34-3.37-1.34-.46-1.16-1.11-1.47-1.11-1.47-.9-.62.07-.6.07-.6 1 .07 1.53 1.03 1.53 1.03.9 1.52 2.34 1.08 2.91.83.09-.65.35-1.08.63-1.33-2.22-.25-4.56-1.11-4.56-4.94 0-1.09.39-1.98 1.03-2.68-.1-.25-.45-1.27.1-2.65 0 0 .84-.27 2.75 1.02a9.6 9.6 0 015 0c1.91-1.29 2.75-1.02 2.75-1.02.55 1.38.2 2.4.1 2.65.64.7 1.03 1.59 1.03 2.68 0 3.84-2.34 4.68-4.57 4.93.36.31.68.92.68 1.85v2.74c0 .26.18.58.69.48A10 10 0 0012 2z' },
  { label: 'Telegram', path: 'M21 4L3 11l6 2m12-9l-4 17-6-7m10-10L9 13' },
  { label: 'LinkedIn', path: 'M6 9H2v12h4V9zM4 6a2 2 0 100-4 2 2 0 000 4zM22 21v-6.5c0-3-1.6-4.4-3.8-4.4-1.75 0-2.53 1-2.97 1.6V10h-4v11h4v-6c0-1.5.28-3 2.1-3s2.1 1.5 2.1 3v6h4z' },
];

function FooterLink({ label, href, newTab }) {
  return (
    <a
      href={href}
      className="footer__link"
      target={newTab ? '_blank' : undefined}
      rel={newTab ? 'noopener noreferrer' : undefined}
    >
      {label}
      {newTab && <span className="footer__link-arrow">↗</span>}
    </a>
  );
}

function FooterColumn({ title, links }) {
  return (
    <div className="footer__col">
      <p className="footer__col-title">{title}</p>
      {links.map((link) => (
        <FooterLink key={link.label} {...link} />
      ))}
    </div>
  );
}

function Footer() {
  const logoUrl = `${process.env.PUBLIC_URL}/images/flare-icon.png`;

  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="footer__brand">
          <div className="footer__brand-row">
            <img src={logoUrl} alt="Flare" className="footer__logo" />
            <span className="footer__tagline">The blockchain for data</span>
          </div>

          <div className="footer__toplinks">
            {TOP_LINKS.map((link) => (
              <a key={link.label} href={link.href} className="footer__toplink">
                {link.label}
              </a>
            ))}
          </div>
        </div>

        <div className="footer__columns">
          <FooterColumn title="Explore" links={EXPLORE_LINKS} />
          <FooterColumn title="Flare" links={FLARE_LINKS} />
        </div>

        <div className="footer__social">
          {SOCIAL_ICONS.map((icon) => (
            <button key={icon.label} type="button" className="footer__social-icon" aria-label={icon.label}>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d={icon.path} stroke="#4a4a4a" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </button>
          ))}
        </div>
      </div>

      <div className="footer__legal">
        <span className="footer__legal-link">UK Disclaimer</span>
        <span className="footer__legal-copyright">© Flare 2026</span>
      </div>
    </footer>
  );
}

export default Footer;